<template>
  <div class="container">
    <div class="handle-box">
      <el-form :model="queryCondition" ref="queryCondition" label-width="120px" class="searchForm">
        <el-row>
          <el-col :span="24">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item :label="$t('supplierManage.suppliercode')" prop="supplierCode">
                  <el-input v-model.trim="queryCondition.supplierCode" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('supplierManage.supplierChinese')" prop="supplierName">
                  <el-input v-model="queryCondition.supplierName" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('supplierManage.supplierEnglish')" prop="supplierNameEn">
                  <el-input v-model="queryCondition.supplierNameEn" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('supplierManage.supplierAbbreviation')" prop="supplierNameShort">
                  <el-input v-model="queryCondition.supplierNameShort" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-collapse-transition>
            <el-col :span="24" v-if="isShow">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item :label="$t('supplierManage.factoryName')" prop="plantName">
                    <el-input v-model.trim="queryCondition.plantName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('supplierManage.Category1')" prop="categoryLevel1Id">
                    <el-select v-model="queryCondition.categoryLevel1Id" clearable @change="changeCategory1()" style="width:100%">
                      <el-option :key="index" v-for="(item, index) in categoryList1" :label="item.name" :value="item.tmCategoryId"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('supplierManage.Category2')" prop="categoryLevel2Id">
                    <el-select v-model="queryCondition.categoryLevel2Id" clearable style="width:100%">
                      <el-option :key="index" v-for="(item, index) in categoryList2" :label="item.name" :value="item.tmCategoryId"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-collapse-transition>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" @click="queryData" type="primary">{{ $t('common.search') }}</el-button>
          <el-button size="mini" @click="restQueryForm" type="primary">{{ $t('common.reset') }}</el-button>
          <span class="arrowDown" @click="isShow = !isShow">{{ isShow ? '收缩' : '展开' }}<i :class="isShow ? 'el-icon-arrow-up iconBtn' : 'el-icon-arrow-down iconBtn'"></i></span>
        </el-row>
      </el-form>
    </div>
    <div class="action-btn-row">
      <el-button size="mini" v-if="isShowFunc && isEmplFlag" class="btn" type="primary" @click="addSupplier('SS')" v-acl="CreateSsSupplier">{{ $t('supplierManage.NewSSsupplier') }}</el-button>
      <!--新建SS供应商-->
      <el-button size="mini" v-if="isShowFunc && isEmplFlag" class="btn" type="primary" @click="addSupplier('MDM')" v-acl="CreateMdmSupplier">{{ $t('supplierManage.NewNoSSsupplier') }}</el-button>
      <!--新建非SS/NFC供应商-->
      <el-button size="mini" v-if="isShowFunc && isEmplFlag" class="btn" type="primary" @click="addSupplier('NFC')" v-acl="CreateNfcSupplier">{{ $t('supplierManage.NewNFC') }}</el-button>
      <!--新建NFC-->
    </div>
    <el-table :data="tableList" ref="tableList" border highlight-current-row max-height='420'>
      <el-table-column min-width="100" show-overflow-tooltip prop="supplierCode" :label="$t('supplierManage.suppliercode')">
        <template slot-scope="scope">
          <div class="a-link" @click="toDetail(scope.row)">{{ scope.row.supplierCode }}</div>
        </template>
      </el-table-column>
      <el-table-column min-width="130" show-overflow-tooltip prop="supplierName" :label="$t('supplierManage.supplierChinese')"></el-table-column>
      <el-table-column min-width="130" show-overflow-tooltip prop="supplierNameEn" :label="$t('supplierManage.supplierEnglish')"></el-table-column>
      <el-table-column min-width="100" show-overflow-tooltip prop="supplierNameShort" :label="$t('supplierManage.supplierAbbreviation')"></el-table-column>
      <el-table-column min-width="100" show-overflow-tooltip prop="groupType" :label="$t('visitPlan.Type')">
        <template slot-scope="scope">{{ scope.row.groupType | ic('TM_SUPPLIER', 'GROUP_TYPE') }}</template>
      </el-table-column>
      <el-table-column min-width="100" show-overflow-tooltip prop="plantName" :label="$t('supplierManage.factoryName')"></el-table-column>
      <el-table-column min-width="80" show-overflow-tooltip prop="linkman" :label="$t('settlementUnit.contacts')"></el-table-column>
      <el-table-column min-width="80" show-overflow-tooltip prop="telephoneNo" :label="$t('common.contactNumber')"></el-table-column>
      <el-table-column min-width="120" show-overflow-tooltip prop="emailAddress" :label="$t('sys.userList.email')"></el-table-column>
      <el-table-column min-width="70" show-overflow-tooltip prop="inviter" :label="$t('settlementUnit.agent')"></el-table-column>
      <el-table-column min-width="60" prop="departmentI18n" :label="$t('settlementUnit.department')"></el-table-column>
      <el-table-column min-width="80" prop="auditStatusI18n" :label="$t('supplierManage.auditStatus')"></el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
    </div>
    <el-dialog :visible.sync="groupTypeDialog" width="30%">
      <!--groupType弹框-->
      <el-form :model="groupTypeForm" ref="groupTypeRef" :rules="groupTypeRules" label-width="110px">
        <el-form-item :label="$t('visitPlan.Type')" prop="groupType">
          <ic-select clearable table="TM_SUPPLIER" field="GROUP_TYPE" :excludes="['CARRIER']" v-model="groupTypeForm.groupType"></ic-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button size="mini" type="primary" @click="groupTypeDialog = false">{{ $t('common.close') }}</el-button>
        <el-button size="mini" type="primary" @click="confirmAddSupplier">{{ $t('common.submit') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { apiService } from "@/api/material/material-master-data";
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";
import supplierApi from "@/api/supplier/supplier";
export default {
  components: { IcSelect },
  name: "",

  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      queryCondition: {
        supplierCode: '',
        supplierName: '',
        supplierNameEn: '',
        supplierNameShort: '',
        plantName: '',
        categoryLevel1Id: '',
        categoryLevel2Id: '',
        pageSize: 15,
        pageNum: 1,
      },
      tableList: [],
      categoryList1: [],
      categoryList2: [],
      groupTypeDialog: false,
      groupTypeForm: {
        groupType: ''
      },
      groupTypeRules: {
        groupType: [{ required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }],
      },
      createType: '',
      emplFlag: '',
      isShowFunc: true,
      isEmplFlag: true
    };
  },
  created() {
    const emplFlag = localStorage.getItem("ms_emplFlag");
    //供应商用户
    if (emplFlag === 'SUP') {
      this.emplFlag = 'SUP';
    }
    this.getCategoryList()
    this.queryData();
  },
  mounted() {
    let dataScope = JSON.parse(localStorage.getItem("ms_DataScope"));
    let groupableSupplier = localStorage.getItem("groupableSupplier")//true是HGS供应商
    console.log('groupableSupplier', groupableSupplier);
    if (groupableSupplier !== 'false') {
      if (dataScope) {
        if (dataScope.indexOf('SUPPLIER_GROUPING') !== -1 || dataScope.indexOf('MATERIALS_AND_FPA_MAINTAINER') !== -1 || dataScope.indexOf('MATERIALS_MAINTAINER') !== -1) {
          this.isShowFunc = false
        } else {
          this.isShowFunc = true
        }
      }
    } else {
      //供应商用户
      if (emplFlag === 'SUP') {
        this.isEmplFlag = false;
      } else {
        this.isEmplFlag = true;
      }
    }
    console.log('isEmplFlag', this.isEmplFlag);
    console.log('isShowFunc', this.isShowFunc);
  },
  methods: {
    queryData(val) {
      let that = this;
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      supplierApi.getResourceList(this.queryCondition).then((res) => {
        console.log(res);
        that.tableList = res.resultData;
        that.totalCount = res.totalCount;
      });
    },
    restQueryForm() {
      this.queryCondition = {
        supplierCode: '',
        supplierName: '',
        supplierNameEn: '',
        supplierNameShort: '',
        plantName: '',
        categoryLevel1Id: '',
        categoryLevel2Id: '',
        pageSize: 15,
        pageNum: 1,
      }
      this.queryData();
    },
    addSupplier(val) {
      this.groupTypeDialog = true
      this.createType = val
    },
    confirmAddSupplier() {
      let that = this
      this.$refs.groupTypeRef.validate(valid => {
        if (valid) {
          that.$router.push({
            path: `/supplierResourceManageList-detail`,
            query: { groupType: that.groupTypeForm.groupType, createType: that.createType }
          });
        } else {
          return false;
        }
      });

    },
    toDetail(row) {
      console.log("🚀 ~ toDetail ~ row:", row)
      if (row.groupType == "CARRIER") {
        this.$router.push({
          path: `/supplierResourceManageList-detail/view`,
          query: { tmSupplierId: row.tmSupplierId, groupType: row.groupType, createType: row.department }
        });
      } else {
        this.$router.push({
          path: `/supplierResourceManageList-detail`,
          query: { tmSupplierId: row.tmSupplierId, groupType: row.groupType, createType: row.department }
        });
      }

    },
    getCategoryList() {
      apiService.findCategory({ categoryLevel: 1 }).then((res) => {
        this.categoryList1 = res.data;
      });
    },
    //根据选中Category1查询Category2
    changeCategory1() {
      this.queryCondition.categoryLevel2Id = null
      this.queryCondition.categoryLevel3Id = null
      this.categoryList2 = []
      this.categoryList3 = []
      apiService.findCategory({ categoryLevel: 2, pid: this.queryCondition.categoryLevel1Id }).then((res) => {
        this.categoryList2 = res.data;
      });
    },
  },
  extends: commonFunction
};
</script>
<style scoped  lang="scss">
.el-table {
  margin-top: 10px;
}

.el-select {
  width: 100%;
}
</style>
<style lang="scss"></style>
